export default __webpack_public_path__ + "static/media/feather _ info.cd733523.svg";